import types from './types';
import globalTypes from '../types';
import API from '../../lib/api';
import {toast} from 'react-toastify';
import ModalsLib from '../../lib/modals';
import WS from '../../lib/websocket';
import { navigate } from '../../utils/navigation';
import {requestForToken} from '../../lib/firebase';
import getBrowserFingerprint from 'get-browser-fingerprint';
import PromotionsUtil from '../../utils/promotions';

export const set = modal => {
    return {
        type: types.set,
        payload: modal
    }
}

export const updateData = (slug, data) => {
    return {
        type: types.update,
        payload: {
            slug,
            data
        }
    }
}

export const resetModal = slug => {
    return {
        type: types.reset,
        payload: slug
    }
}


// Wallet
export const setWalletPreset = ({
    tab,
    mode,
    method
}) => {
    return {
        type: types.wallet.preset,
        payload: {
            tab,
            mode,
            method
        }
    }
}

export const setWalletTab = tab => {
    return {
        type: types.wallet.tab,
        payload: tab
    }
}

export const redeemPromotionDepositBonus = (modal_key) => async dispatch => {
    dispatch({
        type: types.update,
        payload: {
            slug: "promotion_deposit_bonus",
            data: {
                button: true
            }
        }
    });

    const response = await API.call({
        path: '/promotions/redeemDepositBonus'
    });

    dispatch({
        type: types.update,
        payload: {
            slug: "promotion_deposit_bonus",
            data: {
                button: false
            }
        }
    });

    if(response.success) {
        PromotionsUtil.clickPromotionModals(modal_key, () => {
            toast.dismiss();
            toast.success(response.message);

            dispatch({
                type: globalTypes.user.pending_voucher,
                payload: response.data.pending_voucher
            });

            ModalsLib.open('wallet');
        });
    } else {
        toast.dismiss();
        toast.error(response.error);
    }
}

export const signUp = data => async dispatch => {
    dispatch({
        type: types.update,
        payload: {
            slug: "signup",
            data: {
                ...data,
                error: "",
                button: true
            }
        }
    });

    const response = await API.call({
        path: '/auth/signup',
        body: {
            uuid: await window.getFingerPrint(),
            phone: data.phone,
            email: data.email,
            username: data.username,
            password: data.password,
            checkbox: data.checkbox ? 1 : 0
        }
    });

    if(!response.success) {
        dispatch({
            type: types.update,
            payload: {
                slug: "signup",
                data: {
                    button: false,
                    error: response.error
                }
            }
        });
    } else {
        ModalsLib.close();

        // Запрашиваем пользователя
        const userResponse = await API.call({
            path: '/auth/user/get'
        });

        if(!userResponse.success) {
            toast.error(userResponse.error);
            window.location.reload();
            return;
        } else {
            toast.success(response.message); // Welcome message
        }

        if(userResponse.user)
            WS.authorize(userResponse.user.userId, userResponse.user.userStringId);

        dispatch({
            type: globalTypes.user.loaded,
            payload: {
                user: userResponse.user,
                logins: userResponse.logins,
                pending_voucher: userResponse.pending_voucher ? {
                    ...userResponse.pending_voucher,
                    expire_at: Date.now() + userResponse.pending_voucher.expire_at
                } : userResponse.pending_voucher,
                facebook: userResponse.facebook,
                modals_list: userResponse.modals_list,
                welcome_bonus: userResponse.welcome_bonus,
                kyc_profile: userResponse.kyc_profile
            }
        });

        if(response.affiliate_bonus)
            ModalsLib.open('affiliate_freeplay');
    }
}

export const signIn = data => async dispatch => {
    dispatch({
        type: types.update,
        payload: {
            slug: "signin",
            data: {
                ...data,
                error: "",
                button: true
            }
        }
    });

    const response = await API.call({
        path: '/auth/signin',
        body: {
            uuid: await window.getFingerPrint(),
            username: data.username,
            password: data.password
        }
    });

    if(!response.success) {
        dispatch({
            type: types.update,
            payload: {
                slug: "signin",
                data: {
                    button: false,
                    error: response.error
                }
            }
        });
    } else {
        ModalsLib.close();

        // Запрашиваем пользователя
        const userResponse = await API.call({
            path: '/auth/user/get'
        });

        if(!userResponse.success) {
            toast.error(userResponse.error);
            window.location.reload();
            return;
        } else {
            toast.success(response.message); // Welcome message
        }

        if(userResponse.user)
            WS.authorize(userResponse.user.userId, userResponse.user.userStringId);

        dispatch({
            type: globalTypes.user.loaded,
            payload: {
                user: userResponse.user,
                logins: userResponse.logins,
                pending_voucher: userResponse.pending_voucher ? {
                    ...userResponse.pending_voucher,
                    expire_at: Date.now() + userResponse.pending_voucher.expire_at
                } : userResponse.pending_voucher,
                facebook: userResponse.facebook,
                modals_list: userResponse.modals_list,
                welcome_bonus: userResponse.welcome_bonus,
                kyc_profile: userResponse.kyc_profile
            }
        });

        // Authorize push token
        // if(Notification.permission === 'granted') {
        //     const token = await requestForToken();

        //     if(token)
        //         await API.call({
        //             path: '/push/authorize',
        //             body: {
        //                 token
        //             }
        //         });
        // }
    }
}

export const completeProfile = (data, game) => async dispatch => {
    dispatch({
        type: types.update,
        payload: {
            slug: "profile_complete",
            data: {
                ...data,
                error: "",
                button: true
            }
        }
    });

    const response = await API.call({
        path: '/auth/user/completeProfile',
        body: data
    });

    if(!response.success) {
        dispatch({
            type: types.update,
            payload: {
                slug: "profile_complete",
                data: {
                    button: false,
                    error: response.error
                }
            }
        });
    } else {
        toast.dismiss();
        toast.success(response.message);

        setTimeout(() => {
            dispatch({
                type: types.update,
                payload: {
                    slug: "profile_complete",
                    data: {
                        button: false
                    }
                }
            });

            dispatch({
                type: globalTypes.user.update,
                payload: response.data
            });

            PromotionsUtil.initializeModals();
        }, 500);

        ModalsLib.close();
    }
}

export const redeemFreeplay = activationId => async dispatch => {
    dispatch({
        type: types.update,
        payload: {
            slug: "freeplay_add",
            data: {
                error: "",
                button: true
            }
        }
    });

    const response = await API.call({
        path: '/freecash/freeplay',
        body: {
            activationId
        }
    });

    if(!response.success) {
        dispatch({
            type: types.update,
            payload: {
                slug: "freeplay_add",
                data: {
                    button: false,
                    error: response.error
                }
            }
        });
    } else {
        dispatch({
            type: globalTypes.games.history.add,
            payload: response.transaction
        });

        if(typeof response.login !== null)
            dispatch({
                type: globalTypes.user.logins.create,
                payload: response.login
            });

        dispatch({
            type: types.update,
            payload: {
                slug: "freeplay_add",
                data: {
                    button: false,
                }
            }
        });
        
        toast.dismiss();
        toast.success(response.message);

        ModalsLib.close();
    }
}

export const EmailConfirmation = {
    stage: stage => {
        return {
            type: types.email_confirmation.stage,
            payload: stage
        }
    },
    change: () => async dispatch => {
        dispatch({
            type: types.email_confirmation.update_user,
            payload: {
                status: 'unconfirmed'
            }
        });

        dispatch({
            type: types.email_confirmation.stage,
            payload: 'unconfirmed'
        });
    },
    enter: email => async dispatch => {
        dispatch({
            type: types.email_confirmation.error,
            payload: null
        });

        dispatch({
            type: types.email_confirmation.toggle_button
        });

        const response = await API.call({
            path: '/verification/email/enter',
            body: {
                email
            }
        });

        dispatch({
            type: types.email_confirmation.toggle_button
        });

        if(!response.success) {
            dispatch({
                type: types.email_confirmation.error,
                payload: response.error
            });
        } else {
            dispatch({
                type: types.email_confirmation.update_user,
                payload: response.email
            });

            dispatch({
                type: types.email_confirmation.stage,
                payload: 'confirmation'
            });
        }
    },
    resend: () => async dispatch => {
        dispatch({
            type: types.email_confirmation.error,
            payload: null
        });

        dispatch({
            type: types.email_confirmation.toggle_resend
        });

        const response = await API.call({
            path: '/verification/email/resend'
        });

        dispatch({
            type: types.email_confirmation.toggle_resend
        });

        if(!response.success) {
            dispatch({
                type: types.email_confirmation.error,
                payload: response.error
            });
        } else {
            dispatch({
                type: types.email_confirmation.update_user,
                payload: response.email
            });
        }
    },
    verify: code => async dispatch => {
        dispatch({
            type: types.email_confirmation.error,
            payload: null
        });

        dispatch({
            type: types.email_confirmation.toggle_button
        });

        const response = await API.call({
            path: '/verification/email/verify',
            body: {
                code
            }
        });

        dispatch({
            type: types.email_confirmation.toggle_button
        });

        if(!response.success) {
            dispatch({
                type: types.email_confirmation.error,
                payload: response.error
            });
        } else {
            toast.dismiss();
            toast.success(response.message);

            dispatch({
                type: types.email_confirmation.update_user,
                payload: response.email
            });

            ModalsLib.close();
        }
    }
}

export const PhoneConfirmation = {
    stage: stage => {
        return {
            type: types.phone_confirmation.stage,
            payload: stage
        }
    },
    change: () => async dispatch => {
        dispatch({
            type: types.phone_confirmation.update_user,
            payload: {
                status: 'unconfirmed'
            }
        });

        dispatch({
            type: types.phone_confirmation.stage,
            payload: 'unconfirmed'
        });
    },
    enter: phone => async dispatch => {
        dispatch({
            type: types.phone_confirmation.error,
            payload: null
        });

        dispatch({
            type: types.phone_confirmation.toggle_button
        });

        const response = await API.call({
            path: '/verification/phone/enter',
            body: {
                phone
            }
        });

        dispatch({
            type: types.phone_confirmation.toggle_button
        });

        if(!response.success) {
            dispatch({
                type: types.phone_confirmation.error,
                payload: response.error
            });
        } else {
            dispatch({
                type: types.phone_confirmation.update_user,
                payload: response.phone
            });

            dispatch({
                type: types.phone_confirmation.stage,
                payload: 'confirmation'
            });
        }
    },
    resend: () => async dispatch => {
        dispatch({
            type: types.phone_confirmation.error,
            payload: null
        });

        dispatch({
            type: types.phone_confirmation.toggle_resend
        });

        const response = await API.call({
            path: '/verification/phone/resend'
        });

        dispatch({
            type: types.phone_confirmation.toggle_resend
        });

        if(!response.success) {
            dispatch({
                type: types.phone_confirmation.error,
                payload: response.error
            });
        } else {
            dispatch({
                type: types.phone_confirmation.update_user,
                payload: response.phone
            });
        }
    },
    verify: code => async dispatch => {
        dispatch({
            type: types.phone_confirmation.error,
            payload: null
        });

        dispatch({
            type: types.phone_confirmation.toggle_button
        });

        const response = await API.call({
            path: '/verification/phone/verify',
            body: {
                code
            }
        });

        dispatch({
            type: types.phone_confirmation.toggle_button
        });

        if(!response.success) {
            dispatch({
                type: types.phone_confirmation.error,
                payload: response.error
            });
        } else {
            toast.dismiss();
            toast.success(response.message);

            dispatch({
                type: types.phone_confirmation.update_user,
                payload: response.phone
            });

            ModalsLib.close();
        }
    }
}

export const AccountRecovery = {
    stage: stage => {
        return {
            type: types.account_recovery.stage,
            payload: stage
        }
    },
    sendUsername: data => async dispatch => {
        dispatch({
            type: types.account_recovery.error,
            payload: null
        });

        dispatch({type: types.account_recovery.toggle_button});

        const response = await API.call({
            path: '/auth/recovery/username',
            body: data
        });

        dispatch({type: types.account_recovery.toggle_button});

        if(!response.success) {
            dispatch({
                type: types.account_recovery.error,
                payload: response.error
            });
        } else {
            toast.dismiss();
            toast.success(response.message);

            ModalsLib.open('signin');
        }
    },
    sendCode: data => async dispatch => {
        dispatch({
            type: types.account_recovery.error,
            payload: null
        });

        dispatch({type: types.account_recovery.toggle_button});

        const response = await API.call({
            path: '/auth/recovery/password/code',
            body: data
        });

        dispatch({type: types.account_recovery.toggle_button});

        if(!response.success) {
            dispatch({
                type: types.account_recovery.error,
                payload: response.error
            });
        } else {
            dispatch({type: types.account_recovery.stage, payload: 'password_code'});
            dispatch({type: types.account_recovery.update_stage, payload: {
                data: {
                    ...response.data,
                    timestamp: Date.now() + (1 * 60 * 1e3)
                }
            }});
        }
    },
    resendCode: data => async dispatch => {
        dispatch({
            type: types.account_recovery.error,
            payload: null
        });

        dispatch({type: types.account_recovery.toggle_resend});

        const response = await API.call({
            path: '/auth/recovery/password/code',
            body: data
        });

        dispatch({type: types.account_recovery.toggle_resend});

        if(!response.success) {
            dispatch({
                type: types.account_recovery.error,
                payload: response.error
            });
        } else {
            dispatch({type: types.account_recovery.update_stage, payload: {
                data: {
                    ...response.data,
                    timestamp: Date.now() + (1 * 60 * 1e3)
                }
            }});
        }
    },
    verifyCode: data => async dispatch => {
        dispatch({
            type: types.account_recovery.error,
            payload: null
        });

        dispatch({type: types.account_recovery.toggle_button});

        const response = await API.call({
            path: '/auth/recovery/password/verify',
            body: data
        });

        dispatch({type: types.account_recovery.toggle_button});

        if(!response.success) {
            dispatch({
                type: types.account_recovery.error,
                payload: response.error
            });
        } else {
            dispatch({type: types.account_recovery.stage, payload: 'password_reset'});
            dispatch({type: types.account_recovery.update_stage, payload: {
                data: response.data
            }});
        }
    },
    resetPassword: data => async dispatch => {
        dispatch({
            type: types.account_recovery.error,
            payload: null
        });

        dispatch({type: types.account_recovery.toggle_button});

        const response = await API.call({
            path: '/auth/recovery/password/reset',
            body: data
        });

        dispatch({type: types.account_recovery.toggle_button});

        if(!response.success) {
            dispatch({
                type: types.account_recovery.error,
                payload: response.error
            });
        } else {
            toast.dismiss();
            toast.success(response.message);

            ModalsLib.open('signin');
        }
    }
}

export const FacebookShare = {
    send: data => async dispatch => {
        dispatch({
            type: types.update,
            payload: {
                slug: 'facebook_share',
                data: {button: true}
            }
        });

        const response = await API.call({
            path: '/tasks/facebook',
            body: data
        });

        dispatch({
            type: types.update,
            payload: {
                slug: 'facebook_share',
                data: {button: false}
            }
        });

        if(!response.success) {
            toast.dismiss();
            toast.error(response.error);
        } else {
            toast.dismiss();
            toast.success(response.message);

            dispatch({
                type: globalTypes.tasks.update.one,
                payload: {
                    type: 'daily',
                    task: 'facebook',
                    data: response.task
                }
            });

            ModalsLib.close();
        }
    }
}

export const FacebookStory = {
    send: data => async dispatch => {
        dispatch({
            type: types.update,
            payload: {
                slug: 'facebook_story',
                data: {button: true}
            }
        });

        const response = await API.call({
            path: '/tasks/facebook_story',
            body: data
        });

        dispatch({
            type: types.update,
            payload: {
                slug: 'facebook_story',
                data: {button: false}
            }
        });

        if(!response.success) {
            toast.dismiss();
            toast.error(response.error);
        } else {
            toast.dismiss();
            toast.success(response.message);

            dispatch({
                type: globalTypes.tasks.update.one,
                payload: {
                    type: 'daily',
                    task: 'facebook_story',
                    data: response.task
                }
            });

            ModalsLib.close();
        }
    }
}